<template>
    <div class="map-public">
        <h2 class="pb-2 text-center">Project Map</h2>
        <div class="map-div">
            <gmap-map
                ref="mapRef"
                :center="{lat:45.5, lng:-122.67}"
                :zoom="10"
                style="width: 100%; height: 100%; padding-top:50%;"
                map-type-id="terrain"/>
        </div>
    </div>
</template>

<script>
import {gmapApi} from 'vue2-google-maps'
import * as _ from 'lodash'

export default {
    name: "MapPublic",
    data() {
        return {
            markers: [],
            polygons: null,
        }
    },
    computed: {
        google: gmapApi,
    },
    async mounted() {
        const projects = (await this.$api.publicMapData(this)).body
        this.$refs.mapRef.$mapPromise.then((map) => {

            let makePolygon = (geom) => {
                new this.google.maps.Polygon({
                    map,
                    paths: geom,
                    strokeColor: '#FFFF00',
                    strokeWeight: 2,
                })

                this.$emit('input', this.paths)
            }
            let makeMarker = (project) => {
                const geom = project.location
                if(geom && geom.length > 0) {
                    let lat = _.meanBy(geom, 'lat')
                    let lng = _.meanBy(geom, 'lng')
                    const marker = new this.google.maps.Marker({
                        position: {lat: lat, lng: lng},
                        map: map,
                        draggable: false,
                    })

                    const contentString =
                        '<div id="content">' +
                        '<div id="siteNotice">' +
                        "</div>" +
                        `<h3>${project.name}</h3>` +
                        `<h5>Agency: ${project.agency ?? 'Unassigned'}</h5>` +
                        `<h5>Contractor: ${project.prime ?? 'Unassigned'}</h5>` +
                        '<div id="bodyContent">' +
                        "</div>" +
                        "</div>";
                    const infowindow = new this.google.maps.InfoWindow({
                        content: contentString,
                    });

                    marker.addListener("mouseover", () => {
                        infowindow.open({
                            anchor: marker,
                            map,
                            shouldFocus: false,
                        });
                    });

                    marker.addListener("mouseout", () => {
                        infowindow.close({
                            anchor: marker,
                            map,
                            shouldFocus: false,
                        });
                    });
                }
            }

            projects.forEach((project) => {
                makeMarker(project)
                makePolygon(project.location)
            })

        })
    }
}
</script>

<style lang="scss">

.map-public {
  margin: 3rem auto 0 auto;
}


.map-div {
    background: #fff;
    padding: 20px;
    border: solid 3px #ddd;
}

@media (max-width: 990px) {
    .map-select .heading {
        position: relative;
        padding-right: 136px;
    }
    .map-select__button {
        position: absolute;
        right: 15px;
        top: 50%;
        transform: translateY(-50%);
    }

}

@media (max-width: 500px) {
    .map-select .heading {
        padding-right: 100px;
    }
    .map-select__button {
        min-height: 38px !important;
        padding: 0 15px !important;
    }
}

</style>